import {Pipe, PipeTransform} from '@angular/core';
import { uniq } from 'lodash';
@Pipe({
  name: 'libAddress'
})

export class LibAddressPipe implements PipeTransform {
  transform(value: string, ...args): string {
    if (!value.includes('ul.')) {
      return uniq(value.split(' ')).join(' ');
    } else {
      return value;
    }
  }
}
